/**
 * Comment timestamp label (OR-1534, Figma "Comment posted" note).
 *
 * For the first 24 hours after posting, a relative label that updates on its
 * own: "Just now", "X min ago", "X hr ago". After that, permanently the
 * absolute "MMM D, YYYY" with 24-hour time — the year always shows, even for
 * the current year. Rendered in the viewer's local time zone from the UTC
 * value the backend stores.
 *
 * The note asks for 24-hour time while the mockups draw only the date
 * ("Sep 8, 2026"); the time follows the written spec, pending design.
 */
const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function formatCommentTime(iso: string, now: number = Date.now()): string {
    const posted = new Date(iso);
    const t = posted.getTime();
    if (Number.isNaN(t)) return "";
    const elapsed = Math.max(0, now - t);
    if (elapsed < MINUTE) return "Just now";
    if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)} min ago`;
    if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)} hr ago`;
    const date = posted.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    const time = posted.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
    return `${date} · ${time}`;
}
